import { colorsPalettes } from "@similarweb/styles";
import { Combobox, TruncatedTextWithTooltip, Type } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import type { IDropDownExtendedItem } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/shared/ControlledMultiDropdown/ControlledMultiDropdown";

import { StyledCombinedIcon } from "./styles";

type Props = {
    item: IDropDownExtendedItem;
    selected?: boolean;
};

// Presentational content only: the row chrome (padding, height, hover band) and the click are owned
// by the wrapping Combobox.Option in SelectCombobox.
export const CompanyDDItem = ({ item, selected }: Props) => (
    <Flex
        alignItems="center"
        justifyContent="space-between"
        gap="8px"
        width="100%"
    >
        <Flex
            alignItems="center"
            gap="8px"
            flex="1"
            minWidth={0}
        >
            <StyledCombinedIcon
                type="itemIcon"
                iconType={Type.Website}
                iconSrc={item.iconSrc ?? ""}
            />
            <TruncatedTextWithTooltip
                fontVariant="input2"
                color={colorsPalettes.carbon[500]}
            >
                {item.text ?? ""}
            </TruncatedTextWithTooltip>
        </Flex>
        <Combobox.OptionCheckbox isChecked={selected ?? item.selected ?? false} />
    </Flex>
);
